import Box from 'components/Box';
import Text from 'components/Text';
import shopSelectors from 'services/shop/selectors';
import styled from 'styled-components';
import { formatCurrency } from 'utils/formatCurrency';
import { formatPhone } from 'utils/formatPhone';
import spellingDollar from 'utils/spellingDollar';

type Props = {
  checkNum?: string;
  date?: string;
  name?: string;
  amount?: number;
  signature?: string;
  checkBank?: {
    bankName: string | null;
    bankAddress: string | null;
    bankWebsite: string | null;
    bankLogo: string | null;
  } | null;
  forCheckNote?: string;
  routerNumber?: string;
  checkingAccount?: string;
  manual?: boolean;
  companyLogo?: string;
};
const CheckUI = ({ signature, companyLogo, checkNum, date, name, amount, checkBank, forCheckNote, manual, routerNumber, checkingAccount }: Props) => {
  const shopInfo = shopSelectors.data.shopInfo();
  const printCheckSetting = shopSelectors.data.printCheckSetting();

  return (
    <Container className='check-border-black-4'>
      <div className="check-container check-border-black-1">
        <CheckSalonItem>
          {!!companyLogo && <Box mr='1'>
            <img src={companyLogo || ''} alt="check-bank" style={{ width: 44, height: 44 }} />
          </Box>}
          <div className="salon-info" style={{ flex: 1 }}>
            <p className="salon-name">{shopInfo?.shopName || '--'}</p>
            <p className="salon-address">{
              shopInfo?.address || '--'
            }</p>
            <p className="salon-address">{
              [shopInfo?.city, shopInfo?.state, shopInfo?.zip].filter(Boolean).join(', ') || '--'
            }</p>
            <p className="salon-address">{formatPhone(shopInfo?.phone || '')}</p>
          </div>
          <div className="check-num">{checkNum || '--'}</div>
          <div className="date-container">
            <span style={{ fontSize: 14 }}>Date</span>
            <div className="date-label"><span>{date || '--'}</span></div>
          </div>
        </CheckSalonItem>
        <CheckItemPayInfo>
          <div className="amount-container">
            <div className="pay-to-order-container" style={{ position: 'relative' }}>
              <div style={{ width: '200px', position: 'absolute' }}>
                <div className="pay-to-order-label">PAY TO THE</div>
                <div className="pay-to-order-label">ORDER OFF</div>
              </div>
              <div className="staff-name-container" style={{ paddingLeft: '208px' }}><span>{name || '--'}</span></div>
            </div>
            <div className="amount-box">
              <div className="symbol">$</div>
              <div className="amount-box-container"><span>{formatCurrency(amount || 0)?.replace('$', '')}</span></div>
            </div>
          </div>
          <div className="dollar-container" style={{ position: 'relative' }}>
            <div className="amount-container">
              <span>{spellingDollar(amount || 0)}  and 0/100 ************************************************************************************************************************************************************************************************************************</span>
            </div>
            <div className="dollar-text"><span>Dollars</span></div>
            <VoidAfter90Days className='dollar-text'>VOID AFTER 90 DAYS</VoidAfter90Days>
          </div>
        </CheckItemPayInfo>
        <MemoItem>
          {checkBank && <div className="check-bank-container">
            {checkBank.bankLogo ? <img src={checkBank.bankLogo || ''} alt="check-bank" style={{ width: 44, height: 44 }} /> : <div style={{ width: 44, height: 44, border: '1px solid black' }} />}
            <div>
              <p>{checkBank.bankName}</p>
              <p>{checkBank.bankAddress}</p>
              <p>{checkBank.bankWebsite}</p>
            </div>
          </div>}
          <div className="top-container">
            <div className="memo-label">For</div>
            <div className="rent-text"><span>{manual ? forCheckNote : (forCheckNote || printCheckSetting?.forCheckNote)}</span></div>
            <div style={{ flex: 1 }}></div>
            <div className="signature-container">
              {signature ? <img src={signature} alt="signature" className="signature-image" /> : <div className='signature-image' />}
              <AuthorizedSignature>Authorized Signature</AuthorizedSignature>
            </div>
          </div>
          <Text style={{ marginTop: '35px' }} />
          {/* <div className="bottom-container micr">
            <div className="group">
              <IconStartNumber /><span>{(manual ? routerNumber : printCheckSetting?.routerNumber) || '---------'}</span><IconEnd4Number />
            </div>
            <div className="group">
              <IconStartNumber /><span>{(manual ? checkingAccount : printCheckSetting?.checkingAccount) || '---------'}</span><IconStartNumber />
            </div>
            <div className="group">
              <span>{checkNum}</span><IconEnd4Number />
            </div>
          </div> */}
          <div className="micr-wrapper">
            <div className="micr-line">
              C00{checkNum}C   A{(manual ? routerNumber : printCheckSetting?.routerNumber)}A   {(manual ? checkingAccount : printCheckSetting?.checkingAccount)}C
            </div>
          </div>
        </MemoItem>
      </div>
    </Container>
  );
};

export default CheckUI;
const VoidAfter90Days = styled.div`
  position: absolute;
  right: 75px;
  bottom: -20px;
  font-family: Poppins;
  font-size: 12px;
  font-weight: 400;
`;

const AuthorizedSignature = styled.div`
  position: absolute;
  bottom: -18px;
  font-family: Poppins;
  font-size: 12px;
  font-weight: 400;
  left: 50%;
  transform: translateX(-50%);
  white-space: nowrap;
`;

const Container = styled.div`
display: flex;
padding: 8px;
flex-direction: column;
align-items: flex-start;
flex-shrink: 0;
background: white;
.check-container {
  display: flex;
  padding: 8px 16px;
  flex-direction: column;
  justify-content: space-between;
  align-items: flex-start;
  flex: 1 0 0;
  align-self: stretch;
  background: white;
}
`;

const MemoItem = styled.div`
display: flex;
flex-direction: column;
align-items: flex-start;
gap: 4px;
align-self: stretch;
position: relative;
.check-bank-container {
  display: flex;
  align-items: center;
  gap: 8px;
  position: absolute;
  top: 8px;
  p {
    color: black;
    font-family: Poppins;
    font-size: 10px;
    line-height: 13px;
    font-style: normal;
    font-weight: 500;
  }
}
.bottom-container {
  display: flex;
  align-items: flex-end;
  align-self: stretch;
  gap: 8px;
  zoom: 0.7;
  transform: translateY(-16px);
  margin-top: 40px;
  .group {
    display: flex;
    align-items: center;
    gap: 4px;
  }
   span {
    font-family: 'ocr-a-regular', monospace;
    color: black;
    height: 18px;
    text-align: center;
    font-size: 18px;
    font-weight: bold;
    opacity: 0.8;
    letter-spacing: 10px;
  }
}
.top-container {
  display: flex;
  align-items: flex-end;
  gap: 14px;
  align-self: stretch;
  .memo-label {
    color: black;
    font-family: Poppins;
    font-size: 14px;
    font-style: normal;
    font-weight: 500;
    line-height: normal;
  }

  .rent-text {
    display: flex;
    width: 193px;
    align-items: center;
    gap: 10px;
    border-bottom: 1px solid black;
    span {
      color: black;
      font-family: Salsa;
      font-size: 16px;
      font-style: normal;
      font-weight: 400;
      line-height: normal;
    }
  }

  .signature-container {
    display: flex;
    align-items: center;
    gap: 10px;
    border-bottom: 1px solid black;
    min-width: 40%;
    position: relative;
    img.signature-image {
      width: auto;
      height: 80px;
      padding-top: 5px;
    }
    div.signature-image {
      width: 100px;
      height: 85px;
    }
  }
}
`;

const CheckItemPayInfo = styled.div`
display: flex;
flex-direction: column;
align-items: flex-start;
gap: 12px;
align-self: stretch;
margin-top: 34px;
.amount-container {
  display: flex;
  align-items: flex-end;
  gap: 24px;
  align-self: stretch;
  .pay-to-order-container {
    display: flex;
    align-items: flex-end;
    gap: 16px;
    flex: 1 0 0;
    .pay-to-order-label {
      color: black;
      font-family: Poppins;
      font-size: 10px;
      width: 100px;
      font-style: normal;
      font-weight: 500;
      line-height: 13px;
    }

    .staff-name-container {
      display: flex;
      align-items: center;
      gap: 10px;
      flex: 1 0 0;
      border-bottom: 1px solid black;
      span {
        color: black;
        font-family: Salsa;
        font-size: 16px;
        font-style: normal;
        line-height: normal;
      }
    }
  }

  .amount-box {
    display: flex;
    align-items: center;
    gap: 8px;
    .symbol {
      color: black;
      font-family: Poppins;
      font-size: 16px;
      font-style: normal;
      font-weight: 500;
      line-height: normal;
    }

    .amount-box-container {
      display: flex;
      padding: 0px 36px;
      justify-content: center;
      align-items: center;
      gap: 10px;
      border: 1px solid black;
      span {
        color: #1D2129;
        text-align: center;
        font-family: Salsa;
        font-size: 16px;
        font-style: normal;
        font-weight: 500;
        line-height: normal;
      }
    }
  }
}


.dollar-container {
  display: flex;
  align-items: center;
  gap: 24px;
  align-self: stretch;
  .amount-container {
    display: flex;
    align-items: center;
    gap: 10px;
    flex: 1 0 0;
    border-bottom: 1px solid black;
    overflow: hidden;
    white-space: nowrap;
    span {
      color: black;
      font-family: Salsa;
      font-size: 16px;
      font-style: normal;
      font-weight: 400;
      line-height: normal;
    }
  }

  .dollar-text {
    display: flex;
    align-items: flex-end;
    gap: 16px;
    align-self: stretch;
    span {
      color: black;
      font-family: Poppins;
      font-size: 16px;
      font-weight: 500;
      font-family: Salsa;
    }
  }
}
`;

const CheckSalonItem = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: flex-start;
  align-self: stretch;
  position: relative;
  margin-bottom: 0px;
  margin-top: 15px;
  .salon-info {
    display: flex;
    width: 200px;
    flex-direction: column;
    align-items: flex-start;
    p.salon-name {
      align-self: stretch;
      color: black;
      font-family: Poppins;
      font-size: 16px;
      font-style: normal;
      font-weight: 700;
      line-height: 16px;
      white-space: nowrap;
    }

    p.salon-address {
      color: black;
      font-family: Poppins;
      font-size: 10px;
      font-style: normal;
      font-weight: 500;
      line-height: 13px;
    }
  }

  .check-num {
    color: black;
    text-align: right;
    font-family: Poppins;
    line-height: normal;
    font-size: 16px;
    font-weight: 500;
    font-family: Salsa;
    transform: translateY(-12px);
  }

  .date-container {
    display: flex;
    align-items: center;
    gap: 8px;
    position: absolute;
    right: 79.13px;
    bottom: 12px;
    z-index: 2;
    span {
      color: black;
      font-family: Poppins;
      font-size: 22px;
      font-style: normal;
      font-weight: 500;
      line-height: normal;
    }
    div.date-label {
      display: flex;
      justify-content: center;
      align-items: center;
      gap: 10px;
      border-bottom: 1px solid #777D7C;

      span {
        font-size: 16px;
        font-weight: 500;
        font-family: Salsa;
      }
    }
  }
`;